module.exports = __webpack_public_path__ + "img/micropayment.2a2ba7c3.png";